import { Schema } from "mongoose"
import { z } from "zod"


const ttlSecondsRaw = process.env.RB_RTS_CHANGES_TTL_S ?? ""
const ttlSeconds = Number.isFinite(Number(ttlSecondsRaw)) ? Math.max(60, Math.floor(Number(ttlSecondsRaw))) : 60 * 60 * 24 * 30

export const ZRBRtsChangeOp = z.enum(["delete", "reset_model"])

export const ZRBRtsChange = z.object({
  seq: z.number().int().min(0),
  modelName: z.string(),
  op: ZRBRtsChangeOp,
  docId: z.string().optional(),
  ts: z.date(),
})

export type IRBRtsChange = z.infer<typeof ZRBRtsChange>

export const RBRtsChangeSchema: Schema = new Schema(
  {
    seq: { type: Number, required: true },
    modelName: { type: String, required: true, index: true },
    op: { type: String, required: true, enum: ZRBRtsChangeOp.options },
    docId: { type: String, required: false },
    ts: { type: Date, required: true, default: Date.now },
  },
  {
    versionKey: false,
  },
)

RBRtsChangeSchema.index({ seq: 1 }, { unique: true })
RBRtsChangeSchema.index({ ts: 1 }, { expireAfterSeconds: ttlSeconds })
